/**
 * Formats a number to include two decimal places.
 * If the number is an integer, ".00" is added.
 * If the number is a float, it ensures two decimal precision.
 *
 * @param value - The number to format
 * @returns The formatted number as a !!!string
 */
export const formatNumberWithDecimals = (value: number): string => {
	return Number.isInteger(value) ? `${value}.00` : value.toFixed(2);
};
